/**
 * PROD-922 — merge the saved Describe answers (the server copy the draft-resume rehydrate reads) over what this
 * mount already holds, instead of replacing it.
 *
 * The rehydrate fetch starts when DescribeSection mounts with no answers. The profile-prefill effect of the same
 * mount finishes first (it is synchronous) and writes profile answers tagged 'profile' in `prefillKeys`; an AI
 * prefill or the patient may add more while the fetch is in flight. Rules:
 *   - a saved answer wins over a PREFILL (any tag) for its field, and that field's prefill tag is dropped — its
 *     value now comes from the saved answers, so a later prefill pass must treat it as the patient's;
 *   - a prefill for a field the saved answers do not contain stays, with its tag;
 *   - an UNTAGGED local answer (the patient answered it on this mount, during the fetch) is newer than the saved
 *     copy and stays.
 * Pure; never mutates its arguments. Gate: scripts/check-describe-rehydrate-merge.mjs.
 */
export function mergeRehydratedAnswers(localAnswers, localPrefillKeys, savedAnswers) {
  const answers = { ...(localAnswers || {}) }
  const prefillKeys = { ...(localPrefillKeys || {}) }
  for (const [k, v] of Object.entries(savedAnswers || {})) {
    if (k in answers && !prefillKeys[k]) continue
    answers[k] = v
    delete prefillKeys[k]
  }
  return { answers, prefillKeys }
}
